// BadRequest - неверный запрос.
// Unauthorized - неавторизованный доступ.
// Forbidden - доступ запрещен.
// NotFound - запрашиваемый ресурс не найден.
// Conflict - конфликт запроса с текущим состоянием сервера.
// PayloadTooLarge - размер данных слишком велик.
// UnsupportedMediaType - тип данных не поддерживается.
// TooManyRequests - слишком много запросов.
// InternalServerError - внутренняя ошибка сервера.
// NotImplemented - функциональность не реализована.
// ServiceUnavailable - сервис недоступен.
// Timeout - Время ожидания шлюза истекло.

export enum ErrorCode {
  BadRequest = 400,
  Unauthorized = 401,
  Forbidden = 403,
  NotFound = 404,
  Conflict = 409,
  PayloadTooLarge = 413,
  UnsupportedMediaType = 415,
  TooManyRequests = 429,
  InternalServerError = 500,
  NotImplemented = 501,
  ServiceUnavailable = 503,
  Timeout = 504,
}

export enum CustomErrorCode {
  NoToken = 1000,
  // ошибка при добавление товара в корзину (не даем оставить не комплект)
  oddQuantityV1 = 1030,
  oddQuantityV2 = 1031,
  oddQuantityV3 = 1032,
  oddQuantityV4 = 1033,

  // ошибки гарантии
  warrantyRecordNotFound = 100000,
  warrantyAlreadyActivated = 110000,

  // ошибки дискондной карты
  thereIsNoSuchDiscountCard = 1800000,
  thereIsACardButTheMailIsDifferent = 1820000,
  thereIsACardButThePhoneNumberIsDifferent = 1840000,
  cardCanceled = 1980000,
  cartInvalidValidation = 1998000,
}
